import { faTimes } from "@fortawesome/free-solid-svg-icons";
import type { FC } from "react";
import { ModalFooter } from "../components/layout/ModalProvider";
import { Paragraph } from "../components/Paragraph";

export const DeleteInspectionFindingModal: FC<{
  onStage: () => void;
}> = (props) => {
  return (
    <>
      <Paragraph>
        <div>Weet je zeker dat je deze bevinding wilt verwijderen?</div>
      </Paragraph>
      <ModalFooter text={"Verwijderen"} icon={faTimes} onSubmit={props.onStage} />
    </>
  );
};
